import Axios from "axios";
import { SETTINGS } from "../../../../../properties/ApiProps";

export const ProfessionalEventTypeRepository = {
  fetch: (id) => {
    return Axios.get(`${SETTINGS.API_URL}professionalEventTypes/${id}`);
  },
  fetchAll: (gradingSchemaId) => {
    return Axios({
      url: SETTINGS.API_URL + "professionalEventTypes",
      method: "GET",
      params: {
        gradingSchemaId: gradingSchemaId,
      },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  create: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "professionalEventTypes",
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  update: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "professionalEventTypes",
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  delete: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}professionalEventTypes/${id}`);
  },
};
